import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

// Icons
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";

// Extras (si los activás)
// import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
// import AttachmentRoundedIcon from "@mui/icons-material/AttachmentRounded";
// import SendRoundedIcon from "@mui/icons-material/SendRounded";

export default function LegalFile() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("buscar expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Buscar Expediente"
              subtitle="Buscar por numero de expediente"
              icon={<ManageSearchRoundedIcon />}
              color="#2563eb"
              to="/legal/file/search"
            />
          </Grid>
        )}

        {hasPermission("generar expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Archivo"
              subtitle="Migrar expediente o Actualizar ubicación mediante Excel"
              icon={<UploadFileRoundedIcon />}
              color="#0ea5e9"
              to="/legalFile/charge"
            />
          </Grid>
        )}

        {hasPermission("ver expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Expedientes"
              subtitle="Ver expedientes cargados"
              icon={<FolderOpenRoundedIcon />}
              color="#10b981"
              to="/legalFile/manager"
            />
          </Grid>
        )}

        {hasPermission("ver expediente fallido") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Expedientes Fallidos"
              subtitle="Ver expedientes fallidos o operaciones fallidas"
              icon={<ReportProblemRoundedIcon />}
              color="#ef4444"
              to="/legalFile/failed"
            />
          </Grid>
        )}

        {/*
        {hasPermission("cargar multiples archivos adjuntos expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Múltiples Archivos"
              icon={<CloudUploadRoundedIcon />}
              color="#f59e0b"
              to="/legalFile/upload/attachments"
            />
          </Grid>
        )}

        {hasPermission("archivos adjuntos expedientes") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Adjuntos de Expedientes"
              icon={<AttachmentRoundedIcon />}
              color="#8b5cf6"
              to="/legalFile/attachments"
            />
          </Grid>
        )}

        {hasPermission("cargar multiples archivos adjuntos expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Escritos a SAC"
              icon={<SendRoundedIcon />}
              color="#64748b"
              to="/legalFile/upload/attachments/text"
            />
          </Grid>
        )}
        */}
      </Grid>
    </Container>
  );
}
